;
define("product_details_information.tpl", function(){});

